var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation_bar"},[(_vm.back)?_c('p',{staticClass:"back_icon iconfont",on:{"click":_vm.backNav}},[_vm._v("")]):_vm._e(),_c('p',{staticClass:"nav_title"},[_vm._v(_vm._s(this.title))]),(_vm.search)?_c('p',{staticClass:"search_icon iconfont",on:{"click":_vm.changesearchbar}},[_vm._v("")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }